import { AfterViewChecked, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../auth/service/auth.service';
import { OrganisationService } from '../../organisation/organisation/services/organisation.service';
import { UserInformation } from '../../requests/Model/userInformation';
import { RequestService } from '../../requests/services/requests.services';
import { TaskService } from '../../tasks/services/tasks.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewChecked, OnDestroy {
  activeRequestCount = 0;
  pendingTasksCount = 0;
  organisationSubscriber?: Subscription;
  activeCountSubscriber?: Subscription;
  pendingCountSubscriber?: Subscription;
  currentUserSubscription?: Subscription;
  currentOrganisation: any;
  currentUser!: UserInformation;
  isError = false;
  errorMessage!: string;
  constructor(private readonly requestService: RequestService,
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly organisationService: OrganisationService,
    private readonly taskService: TaskService) {    
  }
  ngOnDestroy(): void {
    this.organisationSubscriber?.unsubscribe();
    this.activeCountSubscriber?.unsubscribe();
    this.pendingCountSubscriber?.unsubscribe();
    this.currentUserSubscription?.unsubscribe();
  }
  ngAfterViewInit(): void {
    this.activeCountSubscriber = this.requestService.countEmitter.subscribe({
      next: (value) => {
        this.activeRequestCount = value;
      }
    });

    this.pendingCountSubscriber = this.taskService.countEmitter.subscribe({
      next: (value) => {
        this.pendingTasksCount = value;
      }
    });
  }
  ngAfterViewChecked() {
    if (this.authService.isAuthorized()) {
      if (this.currentOrganisation == null || this.currentOrganisation === "") {       
        this.router.navigate(['/organisation'], { relativeTo: this.route });        
      }
      
    }
  }
  ngOnInit(): void {
    this.organisationSubscriber = this.organisationService.organisationEmitter.subscribe({
      next: (value: string) => {
        if (value === '') { this.currentOrganisation = this.organisationService.getLocalStorageItem("CurrentOrganisation") }
        else { this.currentOrganisation = value; }
      }
    });
    if (this.currentOrganisation != null && this.currentOrganisation !== "") {
      this.GetCurrentUser();
    }
    
  }
  GetCurrentUser() {
    this.currentUserSubscription = this.requestService.getCurrentUser().subscribe({
      next: (user: UserInformation) => {
        this.currentUser = user;
      },
      error: (err: any) => {
        this.isError = true;
        this.errorMessage = err.error;
      },
      complete: () => { }
    });
  }

}
